import { createApp } from 'vue';
import store from '../../vuex/store';
import router from '../router';
import LoanCalculatorVue from '../components/LoanCalculator.vue';

class LoanCalculator {
  constructor(el) {
    this.vue = createApp(LoanCalculatorVue, { ...el.dataset });
    this.vue.use(store);
    this.vue.use(router);
    this.vue.mount(el);
  }

  init() {
    console.log('Component LoanCalculator loaded');
  }
}

export default LoanCalculator;
